import React from "react";
import SmartRtpTablePage from "./components/SmartRtpTablePage";
import { RUNTIME_STATUS_TABS } from "./config";
import { getRuntimeLogs } from "../../../controllers/V1/smartRtp/smartRtpController";

export default function SmartRtpRuntimePage() {
  return (
    <SmartRtpTablePage
      title="Smart RTP Runtime"
      activeKey="runtime"
      fetchData={getRuntimeLogs}
      statusTabs={RUNTIME_STATUS_TABS}
      statusField="log_level"
      searchFields={["message", "correlation_id", "log_category", "source"]}
      exportFileName="Smart RTP Runtime Logs"
      columns={[
        { key: "log_level", label: "Level" },
        { key: "log_category", label: "Category" },
        { key: "message", label: "Message" },
        { key: "source", label: "Source" },
        { key: "correlation_id", label: "Correlation Id" },
        { key: "createdAt", label: "Created At" },
      ]}
    />
  );
}
